import React from 'react';

/**
 * The "Ally Connect" wordmark lockup (icon + text), matching the sidebar's
 * brand mark exactly (`Sidebar.tsx`'s `.sidebar-brand-logo-wrap` /
 * `.sidebar-brand-logo` / `.sidebar-brand-text`, same `/img/ally_icon.svg`
 * asset) — used wherever a standalone page (no sidebar visible) needs the
 * same brand mark shown elsewhere in the app (sc-46061 #5: the API Keys
 * 403 page was showing the AceUp logo instead of this one).
 *
 * Uses an inline style for the wordmark color rather than an `au-*`
 * Tailwind utility class: this app's `tailwind.config.js` color extension
 * isn't wired up (no `@config` in `index.css`, see `api_keys.css`'s own
 * note on this), so `text-au-primary-blue` would silently apply nothing.
 */
const AllyConnectLogo: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'flex items-center gap-2'}>
    <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden">
      <img
        src="/img/ally_icon.svg"
        alt="Ally Connect"
        className="block h-6 w-[33px] object-contain"
      />
    </span>
    <span className="font-medium leading-8 tracking-[-0.2px] whitespace-nowrap ally-connect-text">
      Ally Connect
    </span>
  </div>
);

export default AllyConnectLogo;
